import * as v from 'valibot';

export const ReportStatus = v.picklist([
	'Rejected',
	'Approved',
	'NotReviewed',
	'NoReport',
]);

export const ReportStatusBody = v.object({
	status: ReportStatus,
});
export type ReportStatus = v.InferOutput<typeof ReportStatus>;
export type ReportStatusBody = v.InferOutput<typeof ReportStatusBody>;

export const ReportSubmitBody = v.variant('approve', [
	v.object({
		approve: v.literal(true),
	}),
	v.object({
		approve: v.literal(false),
		rejectReasonId: v.number(),
		rejectReason: v.nullish(v.string()),
	}),
]);

export type ReportSubmitBody = v.InferOutput<typeof ReportSubmitBody>;
